/**
 * 予約情報
 */
import deepmerge from 'deepmerge'
import * as C from '@/consts'

export const init = {
  // 初期化されたか
  initialized: false,

  // 予約ID
  reserveID: 0,

  // 保存されたか
  saved: false,

  // 予約ステーションID & 店舗ID
  station: {
    stationID: 0,
    shopID: 0,
    name: '',
    address: '',
    map: ''
  },

  // 予約可能期間
  allow: null,

  // 予約期間
  schedule: {
    status: C.INPUT_NONE,
    begin: '',
    end: ''
  },

  // 車両
  choosedCar: false,
  car: null,

  // 期間情報
  period: null,

  // オプション
  options: [],

  // 免責補償
  insurance: {
    status: C.INPUT_NONE,
    id: 0,
    name: '',
    unitCharge: 0,
    maxDays: Infinity
  },

  // 送迎
  pick: {
    value: C.WAY_NONE,
    place: '',
    oneway: 0,
    round: 0
  },

  // 配車
  deli: {
    value: C.WAY_NONE,
    place: '',
    oneway: 0,
    round: 0
  },

  // 乗り捨て
  returns: {
    station: null
  },

  // フライト
  flights: {
    decided: true,
    arrival: '',
    departure: ''
  },

  // 乗車人数
  peoples: 1,

  // クーポン
  coupon: null,

  // 連絡事項
  note: '',

  // 支払方法
  pay: null
}

export default deepmerge(init, {})
